export const DOCUMENT_RENDERER_CONTENT_TEST_ID = 'document-renderer-content';
export const DOCUMENT_RENDERER_TIFF_IMAGE_TEST_ID = 'document-renderer-tiff-image';
export const DOCUMENT_RENDERER_WEB_IMAGE_TEST_ID = 'document-renderer-web-image';
export const DOCUMENT_VIEWER_CONTROL_MENU_BUTTON_TEST_ID = 'document-viewer-control-menu-button';
export const DOCUMENT_VIEWER_CONTROL_MENU_ITEM_TEST_ID = 'document-viewer-control-menu-item';
export const DOCUMENT_VIEWER_DETAIL_FIELD_TEST_ID = 'document-viewer-detail-field';
export const DOCUMENT_VIEWER_HEADER_FIELD_TEST_ID = 'document-viewer-header-field';
export const VERTICAL_SUB_NAVIGATION_DOCK_TEST_ID = 'vertical-sub-navigation-dock';
export const VERTICAL_SUB_NAVIGATION_EXPAND_COLLAPSE_BUTTON_TEST_ID =
  'vertical-sub-navigation-dock-expand-collapse-button';
export const SUB_NAVIGATION_BAR_TEST_ID = 'sub-navigation-bar';
export const SUB_NAVIGATION_DRAWER_BUTTON_TEST_ID = 'sub-navigation-drawer-button';
export const DOCUMENT_VIEWER_TABLE_TEST_ID = 'document-viewer-table';
export const DOCUMENT_VIEWER_SECTION_CLASSNAME = 'document-viewer-section' as const;
export const DOCUMENT_VIEWER_SECTION_TEST_ID = 'document-viewer-section';
export const DOCUMENT_VIEWER_SECTION_HEADING_TEST_ID = 'document-viewer-section-heading';
export const DOCUMENT_VIEWER_BR_TEST_ID = 'document-viewer-br';
export const DOCUMENT_VIEWER_GENERIC_TEXT_SPAN_TEST_ID = 'document-viewer-generic-text-span';
export const DOCUMENT_VIEWER_INLINE_TEXT_SPAN_TEST_ID = 'document-viewer-inline-text-span';
export const DOCUMENT_VIEWER_GENERIC_HTML_SPAN_TEST_ID = 'document-viewer-generic-html-span';
export const DOCUMENT_VIEWER_LIST_TEST_ID = 'document-viewer-list';
export const DOCUMENT_VIEWER_LIST_ITEM_TEST_ID = 'document-viewer-list-item';
export const DOCUMENT_VIEWER_LINK_TEST_ID = 'document-viewer-link';
export const DOCUMENT_VIEWER_HEADING_TEST_ID = 'document-viewer-heading';
export const MAIN_NAVIGATION_BAR_TEST_ID = 'main-navigation-bar';
export const MAIN_NAVIGATION_BAR_DRAWER_BUTTON_TEST_ID = 'main-navigation-bar-drawer-button';
export const MAIN_NAVIGATION_BAR_DRAWER_SCRIM_TEST_ID = 'main-navigation-bar-drawer-scrim';
export const DOCUMENT_VIEWER_TABS_TEST_ID = 'document-viewer-tabs';
export const DOCUMENT_VIEWER_TAB_TEST_ID = 'document-viewer-tab';
export const DOCUMENT_VIEWER_TAB_MENU_BUTTON_TEST_ID = 'document-viewer-tab-menu-button';
export const DOCUMENT_VIEWER_TAB_MENU_TEST_ID = 'document-viewer-tab-menu';
export const DOCUMENT_VIEWER_TAB_MENU_ITEM_TEST_ID = 'document-viewer-tab-menu-item';
export const TABLE_OF_CONTENTS_SCROLL_SPY_VERTICAL_TEST_ID =
  'table-of-contents-scroll-spy-vertical';
export const TABLE_OF_CONTENTS_SCROLL_SPY_VERTICAL_ITEM_TEST_ID =
  'table-of-contents-scroll-spy-vertical-item';
export const TABLE_OF_CONTENTS_SCROLL_SPY_HORIZONTAL_TEST_ID =
  'table-of-contents-scroll-spy-horizontal';
export const TABLE_OF_CONTENTS_SCROLL_SPY_HORIZONTAL_ITEM_TEST_ID =
  'table-of-contents-scroll-spy-horizontal-item';
export const TABLE_OF_CONTENTS_SCROLL_SPY_HORIZONTAL_MENU_BUTTON_TEST_ID =
  'table-of-contents-scroll-spy-horizontal-menu-button';
export const TABLE_OF_CONTENTS_SCROLL_SPY_HORIZONTAL_MENU_TEST_ID =
  'table-of-contents-scroll-spy-horizontal-menu';
export const TABLE_OF_CONTENTS_SCROLL_SPY_HORIZONTAL_MENU_ITEM_TEST_ID =
  'table-of-contents-scroll-spy-horizontal-menu-item';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_CLOSE_TEST_ID = 'document-viewer-control-button-close';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_BACK_TEST_ID = 'document-viewer-control-button-back';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_PRINT_TEST_ID = 'document-viewer-control-button-print';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_DOWNLOAD_RAW_TEST_ID =
  'document-viewer-control-button-download-raw';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_DOWNLOAD_PDF_TEST_ID =
  'document-viewer-control-button-download-pdf';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_OPEN_IN_NEW_TAB_TEST_ID =
  'document-viewer-control-button-open-in-new-tab';
export const DOCUMENT_VIEWER_CONTROL_MENU_DOWNLOAD_TEST_ID =
  'document-viewer-control-menu-download';
export const MAIN_CONTENT_SHEET_TEST_ID = 'main-content-sheet';
export const DETAIL_CONTENT_SHEET_TEST_ID = 'detail-content-sheet';
